(function() {
  function postAjax(url, data, success) {
    var params = typeof data == 'string' ? data : Object.keys(data).map(
      function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
      }
    ).join('&');

    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
      if (xhr.readyState > 3 && xhr.status == 200) {
        success(xhr.responseText);
      }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  function getGoogleOptimizeExperimentId() {
    var _gaexp = getCookie('_gaexp');
    if (_gaexp) {
      var fields = _gaexp.split(/(?:\.|!)+/);
      var indexExp = 2;
      window.googleOptmize = [];
      var cartNote = '';

      for (var i = 2; i < fields.length; i += 3) {
        var indexVar = indexExp + 2;

        var expID = fields[indexExp];
        // var varID = window.google_optimize.get(fields[indexExp]);
        var varID = fields[indexVar];

        if (expID != undefined) {
          window.googleOptmize.push({
            'expID': expID,
            'varID': varID
          });

          indexExp = indexExp + 3;
          cartNote += 'expID: ' + expID + ' - varID: ' + varID + ' | ';
        }

      }

      sessionStorage.setItem('GoogleOptimizeCampaignData', JSON.stringify(window.googleOptmize));
      console.log(cartNote);

      postAjax('/cart/update.js', {
        note: cartNote
      }, function(data) {
        console.log(JSON.parse(data));
      });
    }
  }

  getGoogleOptimizeExperimentId();
})();
